import { Base, Component, Inject } from '@/vue-property-decorator'
import { ImgEvents } from '@/components/img'
import { SquareProps } from '../basePropsConfig'
import LogoHasBackground from './logoHasBackground'
import LogoLone from './logoLone'
import style from './style.module.scss'
type ScopedSlot = {
  logoSlot: void
}
/** 广告图片盒子 */
@Component<AdvertisementImgBox>({
  name: 'AdvertisementImgBox'
})
export default class AdvertisementImgBox extends Base<
  unknown,
  unknown,
  ImgEvents,
  ScopedSlot
> {
  /** 右下角单独的logo图标 */
  public static LogoLone = LogoLone
  /** 带有背景色的右下角log */
  public static LogoHasBackground = LogoHasBackground

  /** 接收根级传入的Props */
  @Inject() cardProps!: Required<SquareProps>

  /** 渲染: 整个图片由元素拼接而成 */
  private renderAssembled() {
    const { imgUrl } = this.cardProps
    return (
      <div
        class={{
          ['advertisement-img-box']: true,
          [style['advertisement-img-box']]: true,
          [style[`type-default`]]: true
        }}
      >
        {/* 广告图片 */}
        <my-img
          options={{ type: 'div' }}
          src={imgUrl}
          class={style['advertisement-img']}
          onLoadedResult={(it) => this.$emit('loadedResult', it)}
        ></my-img>
        {/* 游戏logo图标slot */}
        {this.$scopedSlots?.logoSlot?.()}
      </div>
    )
  }
  /** 渲染: 一整张图片 */
  private renderIndividual() {
    const { imgUrl } = this.cardProps
    return (
      <my-img
        src={imgUrl}
        class={{
          ['advertisement-img-box']: true,
          [style['advertisement-img-box']]: true,
          [style[`type-default`]]: true
        }}
        options={{ type: 'div' }}
        onLoadedResult={(it) => this.$emit('loadedResult', it)}
      ></my-img>
    )
  }

  render() {
    // 判断一下完整图片,或者拼接的图片
    if (this.cardProps.isCustomIcon) {
      return this.renderIndividual()
    } else {
      return this.renderAssembled()
    }
  }
}
